/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/PerformanceIndicatorPollBatchUserReportPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/PerformanceIndicatorPollBatchUserReportPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PerformanceIndicatorPollBatchUserApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.PerformanceIndicatorPollBatchUserReportPaginationSlice);
  }
}(this, function(ApiClient, PerformanceIndicatorPollBatchUserReportPaginationSlice) {
  'use strict';

  /**
   * PerformanceIndicatorPollBatchUser service.
   * @module api/PerformanceIndicatorPollBatchUserApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new PerformanceIndicatorPollBatchUserApi. 
   * @alias module:api/PerformanceIndicatorPollBatchUserApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the performanceIndicatorPollBatchUserIgnorePollGet operation.
     * @callback module:api/PerformanceIndicatorPollBatchUserApi~performanceIndicatorPollBatchUserIgnorePollGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * IgnorePoll
     * @param {String} _4SAPIAppID 
     * @param {Integer} pollBatchUserID 
     * @param {module:api/PerformanceIndicatorPollBatchUserApi~performanceIndicatorPollBatchUserIgnorePollGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorPollBatchUserIgnorePollGet = function(_4SAPIAppID, pollBatchUserID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorPollBatchUserIgnorePollGet";
      }

      // verify the required parameter 'pollBatchUserID' is set
      if (pollBatchUserID == undefined || pollBatchUserID == null) {
        throw "Missing the required parameter 'pollBatchUserID' when calling performanceIndicatorPollBatchUserIgnorePollGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'pollBatchUserID': pollBatchUserID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorPollBatchUser/IgnorePoll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorPollBatchUserLoadAllInTimePeriodGet operation.
     * @callback module:api/PerformanceIndicatorPollBatchUserApi~performanceIndicatorPollBatchUserLoadAllInTimePeriodGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PerformanceIndicatorPollBatchUserReportPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAllInTimePeriod
     * @param {String} _4SAPIAppID 
     * @param {Integer} pollSettingID 
     * @param {Date} startDate 
     * @param {Date} endDate 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.onlyUnanswered  (default to false)
     * @param {module:api/PerformanceIndicatorPollBatchUserApi~performanceIndicatorPollBatchUserLoadAllInTimePeriodGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PerformanceIndicatorPollBatchUserReportPaginationSlice}
     */
    this.performanceIndicatorPollBatchUserLoadAllInTimePeriodGet = function(_4SAPIAppID, pollSettingID, startDate, endDate, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorPollBatchUserLoadAllInTimePeriodGet";
      }

      // verify the required parameter 'pollSettingID' is set
      if (pollSettingID == undefined || pollSettingID == null) {
        throw "Missing the required parameter 'pollSettingID' when calling performanceIndicatorPollBatchUserLoadAllInTimePeriodGet";
      }

      // verify the required parameter 'startDate' is set
      if (startDate == undefined || startDate == null) {
        throw "Missing the required parameter 'startDate' when calling performanceIndicatorPollBatchUserLoadAllInTimePeriodGet";
      }

      // verify the required parameter 'endDate' is set
      if (endDate == undefined || endDate == null) {
        throw "Missing the required parameter 'endDate' when calling performanceIndicatorPollBatchUserLoadAllInTimePeriodGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'pollSettingID': pollSettingID,
        'startDate': startDate,
        'endDate': endDate,
        'onlyUnanswered': opts['onlyUnanswered']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = PerformanceIndicatorPollBatchUserReportPaginationSlice;

      return this.apiClient.callApi(
        '/PerformanceIndicatorPollBatchUser/loadAllInTimePeriod', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorPollBatchUserSendRemindersToUnansweredUsersFromPeriodGet operation.
     * @callback module:api/PerformanceIndicatorPollBatchUserApi~performanceIndicatorPollBatchUserSendRemindersToUnansweredUsersFromPeriodGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * sendRemindersToUnansweredUsersFromPeriod
     * @param {String} _4SAPIAppID 
     * @param {Integer} pollSettingID 
     * @param {Date} startDate 
     * @param {Date} endDate 
     * @param {module:api/PerformanceIndicatorPollBatchUserApi~performanceIndicatorPollBatchUserSendRemindersToUnansweredUsersFromPeriodGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorPollBatchUserSendRemindersToUnansweredUsersFromPeriodGet = function(_4SAPIAppID, pollSettingID, startDate, endDate, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorPollBatchUserSendRemindersToUnansweredUsersFromPeriodGet";
      }

      // verify the required parameter 'pollSettingID' is set
      if (pollSettingID == undefined || pollSettingID == null) {
        throw "Missing the required parameter 'pollSettingID' when calling performanceIndicatorPollBatchUserSendRemindersToUnansweredUsersFromPeriodGet";
      }

      // verify the required parameter 'startDate' is set
      if (startDate == undefined || startDate == null) {
        throw "Missing the required parameter 'startDate' when calling performanceIndicatorPollBatchUserSendRemindersToUnansweredUsersFromPeriodGet";
      }

      // verify the required parameter 'endDate' is set
      if (endDate == undefined || endDate == null) {
        throw "Missing the required parameter 'endDate' when calling performanceIndicatorPollBatchUserSendRemindersToUnansweredUsersFromPeriodGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'pollSettingID': pollSettingID,
        'startDate': startDate,
        'endDate': endDate
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorPollBatchUser/sendRemindersToUnansweredUsersFromPeriod', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
